"use client";

import { useTranslations } from "next-intl";

const STEP_KEYS = [
	{ titleKey: "step1Title", descKey: "step1Desc" },
	{ titleKey: "step2Title", descKey: "step2Desc" },
	{ titleKey: "step3Title", descKey: "step3Desc" },
	{ titleKey: "step4Title", descKey: "step4Desc" },
	{ titleKey: "step5Title", descKey: "step5Desc" },
	{ titleKey: "step6Title", descKey: "step6Desc" },
] as const;

export interface MoldMakingProcessesProps {
	/** 翻译命名空间：title、description、ctaButton、step1～6 Title/Desc */
	translationNamespace: string;
	/** 顶部 CTA 按钮外链 */
	ctaHref?: string;
}

/**
 * Mold Making Processes：浅灰底、左标题+描述+右侧绿按钮、3×2 白卡片网格（绿底序号 + 标题 + 正文）
 */
export default function MoldMakingProcesses({
	translationNamespace,
	ctaHref = "/upload",
}: MoldMakingProcessesProps) {
	const t = useTranslations(translationNamespace);

	return (
		<section className="w-full py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="mb-6 sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("title")}
					</h2>
					<div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between lg:gap-8">
						<p className="text-sm leading-relaxed text-black md:text-base lg:max-w-[60%] lg:flex-1">
							{t("description")}
						</p>
						<div className="shrink-0">
							<a
								href={ctaHref}
								target="_blank"
								rel="noopener noreferrer"
								className="inline-flex shrink-0 items-center justify-center rounded-lg bg-themePrimary400 px-6 py-3.5 text-center text-sm font-semibold text-white shadow-sm transition hover:opacity-95 sm:px-8 sm:text-base"
							>
								{t("ctaButton")}
							</a>
						</div>
					</div>
				</div>

				<div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
					{STEP_KEYS.map((step, index) => (
						<div
							key={step.titleKey}
							className="flex flex-col bg-white p-6 pt-0 shadow-[0_2px_12px_rgba(0,0,0,0.08)]"
						>
							<div
								className="mb-4 flex h-10 w-10 shrink-0 items-center justify-center bg-themePrimary400 text-base font-bold text-white"
								aria-hidden
							>
								{index + 1}
							</div>
							<h3 className="mb-3 text-lg font-bold text-black sm:text-xl md:text-2xl">{t(step.titleKey)}</h3>
							<p className="text-sm leading-relaxed text-black md:text-base">{t(step.descKey)}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
